import React from 'react';
import { useSelector } from 'react-redux';

// components and helpers
import Notification from '../components/Notifications/Notification';
import Confirmation from '../components/Confirmation/Confirmation';
import Navbar from '../components/Shared/Navbar';
import AppProvider from './AppProviderWrapper';
import ProgressSnackbar from '../components/Workspace/DataSources/ImportWizard/ProgressSnackbar';

// mui
import Box from '@mui/material/Box';
import { CssBaseline } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from '@mui/material/Stack';

function ComponentWrapper<T>(
    WrappedComponent: React.ComponentType<T>
): (props: T) => JSX.Element {
    const ComponentWithWrapper = (props: T) => {
        const theme = useTheme();
        const matches = useMediaQuery(theme.breakpoints.down('md'));
        const exportingDashboard = useSelector(
            (state: any) => state.dashboard.exporting
        );
        const fileImportEventLoading = useSelector(
            (state: any) => state.workspace.fileImportEventLoading
        );

        return (
            <AppProvider>
                <Box
                    sx={{
                        display: matches ? 'grid' : 'flex',
                        marginTop: matches ? -37 : 0,
                    }}
                >
                    <CssBaseline />
                    <Navbar>
                        {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
                        {/*@ts-ignore*/}
                        <WrappedComponent {...props} />
                    </Navbar>
                </Box>
                <Notification />
                <Confirmation />
                <Stack spacing={1}>
                    <ProgressSnackbar
                        processInProgress={exportingDashboard}
                        title={'Exporting Analytics'}
                        tooltipText={'Exporting Analytics'}
                        key={`snackbar_export`}
                    />
                    <ProgressSnackbar
                        processInProgress={fileImportEventLoading}
                        title={'Importing Data'}
                        tooltipText={'Importing Data'}
                        key={`snackbar_import`}
                    />
                </Stack>
            </AppProvider>
        );
    };

    return ComponentWithWrapper;
}

export default ComponentWrapper;
